import { storageKey } from '../lib/storage'
import type { ThemeMode, ThemePreference } from '../stores/theme.store'
import type { LocaleKey } from '../stores/locale.store'
import type { User, UserPermissions } from '../stores/auth.store'

// Raw sessionStorage key: recovery must verify that the write succeeded before reloading.
export const chunkReloadAttemptKey = 'supplier:chunk-reload-attempted'

export const storage = {
  token: storageKey<string>('token'),
  tenantId: storageKey<string>('supplier:tenant-id'),
  user: storageKey<User>('user'),
  permissions: storageKey<UserPermissions>('permissions'),
  theme: storageKey<ThemePreference | ThemeMode>('theme'),
  locale: storageKey<LocaleKey>('locale'),
  location: storageKey<string>('location'),
  // 示例：带默认 TTL 的缓存 key，业务调用 set 时可覆盖
  // import { TTL } from '../lib/storage'
  // supplierList: storageKey<Supplier[]>('supplier:list', { ttl: TTL.DAY }),
} satisfies Record<string, ReturnType<typeof storageKey>>
